module.exports = __webpack_public_path__ + "img/jordan.df6abc67.jpg";